import type { ReactNode } from 'react'

type Tone =
  | 'pending'
  | 'partial'
  | 'paid'
  | 'failed'
  | 'refunded'
  | 'trial'
  | 'active'
  | 'suspended'
  | 'cancelled'
  | 'overdue'
  | 'neutral'

const tones: Record<Tone, string> = {
  pending: 'bg-warning-tint text-warning border-warning-border',
  partial: 'bg-warning-tint text-warning border-warning-border',
  trial: 'bg-warning-tint text-warning border-warning-border',
  paid: 'bg-success-tint text-success border-success-border',
  active: 'bg-success-tint text-success border-success-border',
  failed: 'bg-danger-tint text-danger border-danger-border',
  overdue: 'bg-danger-tint text-danger border-danger-border',
  suspended: 'bg-danger-tint text-danger border-danger-border',
  refunded: 'bg-surface-subtle text-fg-muted border-border',
  cancelled: 'bg-surface-subtle text-fg-muted border-border',
  neutral: 'bg-surface-subtle text-fg-muted border-border',
}

export function StatusPill({
  tone,
  children,
}: {
  tone: Tone | (string & {})
  children?: ReactNode
}) {
  const cls = tones[tone as Tone] ?? tones.neutral
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium capitalize ${cls}`}
    >
      {children ?? tone}
    </span>
  )
}
